import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ThemeService } from '../theme.service';

@Component({
  selector: 'sbe-theme-toggle',
  imports: [MatIconButton, MatIconModule],
  template: `
    <button
      mat-icon-button
      type="button"
      [attr.aria-label]="theme.mode() === 'dark' ? '라이트 모드로 전환' : '다크 모드로 전환'"
      (click)="theme.toggle()"
    >
      <mat-icon>{{ theme.mode() === 'dark' ? 'light_mode' : 'dark_mode' }}</mat-icon>
    </button>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemeToggleComponent {
  protected readonly theme = inject(ThemeService);
}
